import { render, staticRenderFns } from "./AddonVimeoUpload.vue?vue&type=template&id=6b4010c4&"
import script from "./AddonVimeoUpload.vue?vue&type=script&lang=js&"
export * from "./AddonVimeoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports